import request from '@/utils/request'


// 查询用户血氧记录列表
export function listBloodOxygen(query) {
  return request({
    url: '/joe/user-blood-oxygen/list',
    method: 'get',
    params: query
  })
}

// 查询用户血氧记录分页
export function pageBloodOxygen(query) {
  return request({
    url: '/joe/user-blood-oxygen/page',
    method: 'get',
    params: query
  })
}

// 查询用户血氧记录详细
export function getBloodOxygen(data) {
  return request({
    url: '/joe/user-blood-oxygen/detail',
    method: 'get',
    params: data
  })
}

// 新增用户血氧记录
export function addBloodOxygen(data) {
  return request({
    url: '/joe/user-blood-oxygen/add',
    method: 'post',
    data: data
  })
}

// 修改用户血氧记录
export function updateBloodOxygen(data) {
  return request({
    url: '/joe/user-blood-oxygen/edit',
    method: 'post',
    data: data
  })
}

// 删除用户血氧记录
export function delBloodOxygen(data) {
  return request({
    url: '/joe/user-blood-oxygen/delete',
    method: 'post',
    data: data
  })
}
